import React from 'react';
import { FaTimes, FaCheckCircle, FaStar, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import styles from './SponsorDrawer.module.css';

// Import your logo
import imageLogoGold from "../../assets/images/BSPLogoTranSmall.png"; 
import imageVolt from "../../assets/images/volt.jpg";

const SponsorDrawer = ({ business, isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!business) return null;

  const handleConnect = () => {
    // 1. Define the destination where we want to go AFTER login.
    // We will create this route "/connect-sponsor/:id" in step 3.
    // 'business.id' should map to the businessUserId based on your banner logic.
    const deepLinkDestination = `/connect-sponsor/${business.id}`;

    // 2. Check if user is already logged in (Token exists)
    const token = localStorage.getItem('token');

    if (token) {
       // If already logged in, go straight there
       navigate(deepLinkDestination);
    } else {
       // 3. If NOT logged in, go to login with returnUrl
       // output: /login?returnUrl=%2Fconnect-sponsor%2F4
       navigate(`/login?returnUrl=${encodeURIComponent(deepLinkDestination)}`);
    }
  };

  // Logic to determine what image to show in the header
  // If business has a specific cover image, use it. Otherwise, use BuildStart branding.
  const hasCoverImage = business.coverImage && business.coverImage.length > 50; // simple check
  
  const headerStyle = hasCoverImage 
    ? { backgroundImage: `url(${business.coverImage})` } 
    : { backgroundColor: '#f9f9f9' }; // Fallback color

  return (
    <>
      <div 
        className={`${styles.backdrop} ${isOpen ? styles.open : ''}`} 
        onClick={onClose}
      />

      <div className={`${styles.drawer} ${isOpen ? styles.open : ''}`}>
        
        <button className={styles.closeBtn} onClick={onClose}>
          <FaTimes />
        </button>

        {/* --- HEADER IMAGE AREA --- */}
        <div className={styles.coverImage} style={headerStyle}>
          
          {/* If no cover image, show the BuildStart Logo centered */}
          {!hasCoverImage && (
            <div className={styles.brandWatermark}>
               <img src={imageVolt} alt="BuildStart" />
            </div>
          )}

          <div className={styles.logoWrapper}>
             <img src={business.image || imageVolt} alt={business.name} />
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.headerInfo}>
             <h2>{business.name}</h2>
             <div className={styles.badges}>
                <span className={styles.verifiedBadge}><FaCheckCircle /> Vetted Sponsor</span>
                <span className={styles.ratingBadge}><FaStar color="#ffd700"/> {business.rating || '5.0'}</span>
             </div>
             <p className={styles.location}><FaMapMarkerAlt /> {business.location || 'Australia Wide'}</p>
          </div>

          <div className={styles.divider} />

          <div className={styles.section}>
            <h3>About This Partner</h3>
            <p>{business.description || "This is a verified premier partner of BuildStart. They have undergone our rigorous 4-point vetting process."}</p>
          </div>

          <div className={styles.actions}>
            <div className={styles.lockedInfo}>
               <p><FaPhoneAlt className={styles.icon}/> +61 4XX XXX XXX</p>
               <p><FaEnvelope className={styles.icon}/> {business.email || 'email@hidden.com'}</p>
               <div className={styles.blurOverlay}>
                 <span>Login to view</span>
               </div>
            </div>

            {/* UPDATED BUTTON */}
            <button className={styles.connectBtn} onClick={handleConnect}>
              Connect / Request Quote
            </button>
            <p className={styles.subText}>Login required to contact verified partners</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SponsorDrawer;
